import React from 'react';
import { CheckCircle } from 'lucide-react';
// ❌ You no longer need this if we're doing a hard redirect
// import { useNavigate } from 'react-router-dom';

const GoLiveStep = () => {
  // const navigate = useNavigate();

  const handleNextForApproachSteps = () => {
    // 🔥 Simple full-page redirect (also refreshes the app)
    // Option 1: if same origin
    window.location.href = '/account/autopilot';

    // Or, if you want it explicit for localhost dev:
    // window.location.href = 'http://localhost:3001/account?tab=autopilot';
  };

  return (
    <div className="text-center">
      <p className="text-slate-600 mb-4">
      </p>
      <button
        onClick={handleNextForApproachSteps}
        className="w-full bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-blue-700 transition-all flex items-center justify-center gap-2"
      >
        <CheckCircle size={20} />
        <span>Start Autopilot</span>
      </button>
    </div>
  );
};

export default GoLiveStep;
